module.exports = __webpack_public_path__ + "static/media/healthcare_n.a730bad9.png";